import React from 'react';
import BusinessIcon from '@mui/icons-material/Business';
import AccountBox from '@mui/icons-material/AccountBox';
import SpellcheckIcon from '@mui/icons-material/Spellcheck';
import Speed from '@mui/icons-material/Speed';
import { routes } from '../../../config/routes/routes';
import { apiRoutes } from '../../../config/api/apiRoutes';
import { SidebarItems } from '../../../config/sidebar/sidebar.types';

export const CORE_SIDEBAR_ITEMS: SidebarItems = {
  general: [
    {
      title: 'SIDEBAR.DASHBOARD',
      icon: <Speed />,
      url: routes.admin.dashboard,
    },
  ],
  settings: [
    {
      title: 'SIDEBAR.COMPANIES',
      icon: <BusinessIcon />,
      url: routes.admin.companies.list,
      apiUrl: apiRoutes.companies.list,
      enabled: process.env.REACT_APP_PLATFORM_ENABLED === 'true',
    },
    {
      title: 'SIDEBAR.USERS',
      icon: <AccountBox />,
      url: routes.admin.users.list,
      apiUrl: apiRoutes.users.list,
    },
    {
      title: 'SIDEBAR.TRANSLATIONS',
      icon: <SpellcheckIcon />,
      url: routes.admin.translations.list,
      apiUrl: apiRoutes.translations.list,
    },
  ],
};

export const CORE_SIDEBAR_COMPONENT_CONFIG = {
  component: null,
};
